module.exports = __webpack_public_path__ + "img/left_brd.38e1edfc.png";